// extracted by mini-css-extract-plugin
module.exports = {"grid":"split-invoice_grid__3wJBL","wrapper":"split-invoice_wrapper__3-O7t"};